<script setup lang="ts">
import {
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogRoot,
  AlertDialogTitle,
} from 'reka-ui'

type Props = {
  open: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:open', value: boolean): void
  (e: 'dismiss'): void
}>()

function onClose(): void {
  emit('dismiss')
  emit('update:open', false)
}
</script>

<template>
  <ClientOnly>
    <AlertDialogRoot :open="open" @update:open="emit('update:open', $event)">
      <AlertDialogPortal>
        <AlertDialogOverlay class="maintenance-dialog-overlay" />
        <AlertDialogContent class="maintenance-dialog-content" aria-describedby="maintenance-updated-desc">
          <AlertDialogTitle class="maintenance-dialog-title">
            Mise à jour terminée
          </AlertDialogTitle>
          <AlertDialogDescription id="maintenance-updated-desc" class="maintenance-dialog-description">
            L’application a bien été mise à jour.
          </AlertDialogDescription>
          <div class="maintenance-dialog-actions">
            <AlertDialogAction as-child>
              <button class="maintenance-dialog-button" type="button" @click="onClose">
                OK
              </button>
            </AlertDialogAction>
          </div>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialogRoot>
  </ClientOnly>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/elpdl/index" as *;

.maintenance-dialog-overlay {
  position: fixed;
  inset: 0;
  background: var(--color-overlay-scrim, var(--color-overlay, rgb(16 16 20 / 60%)));
  z-index: 2000;
}

.maintenance-dialog-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(560px, calc(100vw - 32px));
  background: var(--color-bg-elevated, #fff);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: $spacing-l;
  z-index: 2001;
}

.maintenance-dialog-title {
  margin: 0 0 $spacing-xs 0;
  font-weight: 700;
}

.maintenance-dialog-description {
  margin: 0;
}

.maintenance-dialog-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: $spacing-m;
}

.maintenance-dialog-button {
  border: 1px solid var(--color-border);
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  border-radius: 6px;
  padding: 8px 14px;
  cursor: pointer;
}
</style>

